import axios from "axios";
import { BASE_URL } from "../constant/staticUrl";

const axiosInstance = axios.create({
  baseURL: BASE_URL, // Your API base URL
});

// 🔹 Request Interceptor: Attach Token & Set Headers Dynamically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }

    // 🔹 Check if the request contains FormData
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 🔹 Response Interceptor: Handle Unauthorized Access
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem("token");
      localStorage.removeItem("mentor");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
